<template>
  <div>
    <DevicePoC22 ref='devicePoC22' ></DevicePoC22>
    <DevicePoC23 ref='devicePoC23' ></DevicePoC23>
  </div>   
</template>

<script>
import DevicePoC22 from './DevicePoC22';
import DevicePoC23 from './DevicePoC23';

export default {
  name: 'DeviceAdapter',
  components:{
    DevicePoC22,
    DevicePoC23,
  },
  props: {    
  },
  data(){
    return {
      currentComponent: null,
    }
  }, 
  methods:{
    setNeSoftwareVersion(neversion) {  
      console.log('setNeSoftwareVersion:', neversion); 
      if (neversion.indexOf("_V22") > 0) {
        this.currentComponent = this.$refs.devicePoC22;
      } else if (neversion.indexOf("_V23") > 0) {
        this.currentComponent = this.$refs.devicePoC23;
      } else {
        this.currentComponent = this.$refs.devicePoC23;
      }
    },
    getAddUserRecords(formData) {
      if (this.currentComponent) {
        return this.currentComponent.getAddUserRecords(formData);
      }      
    },
    getModUserRecords(param, recordData) {
      if (this.currentComponent) {
        return this.currentComponent.getModUserRecords(param, recordData);
      }      
    },
    getQryUserRecords(param) {
      if (this.currentComponent) {
        return this.currentComponent.getQryUserRecords(param);
      }      
    },
    getDelUserRecords(param) {
      if (this.currentComponent) {
        return this.currentComponent.getDelUserRecords(param);
      }      
    },
    getBatchModUserRecords(param, recordData) {
      if (this.currentComponent) {
        return this.currentComponent.getBatchModUserRecords(param, recordData);
      } 
    }
  },
}
</script>